'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhonelinkLock = function MdPhonelinkLock(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.9 18.4v-2.5c0-1.4-1.2-2.2-2.5-2.2s-2.5 0.8-2.5 2.2v2.5h5z m2.1 0c1 0 2 0.9 2 2.1v5.8c0 1-1 2.1-2.2 2.1h-9.1c-1 0-2.1-1.1-2.1-2.2v-5.9c0-1 1.1-1.9 2.1-1.9v-2.5c0-2.4 2.3-4.3 4.7-4.3s4.6 1.9 4.6 4.3v2.5z m13.6-16.8c1.8 0 3.4 1.6 3.4 3.4v30c0 1.8-1.6 3.4-3.4 3.4h-16.6c-1.8 0-3.4-1.6-3.4-3.4v-5h3.4v3.4h16.6v-26.8h-16.6v3.4h-3.4v-5c0-1.8 1.6-3.4 3.4-3.4h16.6z' })
        )
    );
};

exports.default = MdPhonelinkLock;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/phonelink-lock.js
// module id = 3647
// module chunks = 168707334958949